<template>
    <rkm-layout-body title="Lista de loteamento">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-loteamento-create' })"
                color="primary"
                authorize="store-cadastro-loteamento"
            >
                Cadastrar loteamento
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/loteamento/List'

export default {
    components: { List },
}
</script>